(() => {
  'use strict';
  if (window.MBINavigationGraceLoaded) return;
  window.MBINavigationGraceLoaded = true;

  const pending = new Map();
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '#nav-wrapper navigation-item-primary';

  function enabled(item) {
    return item?.matches?.(selector) && hover.matches &&
      document.querySelector('#nav-wrapper .header')?.dataset.ux !== 'click';
  }

  function cancel(item) {
    window.clearTimeout(pending.get(item));
    pending.delete(item);
  }

  function close(item) {
    cancel(item);
    if (item.isConnected && item.isOpen && typeof item.close === 'function') item.close();
  }

  document.addEventListener('mouseleave', event => {
    const item = event.target;
    if (!enabled(item) || typeof item.close !== 'function') return;
    event.stopImmediatePropagation();
    cancel(item);
    pending.set(item, window.setTimeout(() => {
      pending.delete(item);
      if (!item.matches(':hover')) close(item);
    }, 300));
  }, true);

  document.addEventListener('mouseenter', event => {
    const item = event.target;
    if (!enabled(item)) return;
    cancel(item);
    document.querySelectorAll(selector).forEach(other => {
      if (other !== item) close(other);
    });
  }, true);

  document.addEventListener('pointerdown', event => {
    for (const item of pending.keys()) {
      if (!item.contains(event.target)) close(item);
    }
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      for (const item of pending.keys()) cancel(item);
    }
  }, true);

  hover.addEventListener('change', () => {
    for (const item of pending.keys()) close(item);
  });
})();
